import axios from "axios";

const API_URL = "https://o6cto7u0pc.execute-api.ap-south-1.amazonaws.com/Stage";
const token = localStorage.getItem("authToken"); 
export const login = async (email, password) => {
  const response = await axios.post(`https://cms.gmart.in/users_login`, {
    email,
    password,
  });
  console.log(response);
  return response.data; // Return response data (e.g., token, user details)
};

export const userRegistration = async (formData) => {
  const response = await axios.post(
    'https://cms.gmart.in/users_registeration',
    formData, // no need to wrap in `{ FormData }`
    {
      headers: {
        'Content-Type': 'application/json',
        // Add token only if needed
        'Authorization': `Bearer ${token}`,
      }
    }
  );
  return response;
};
export const AssignUserToWebsite = async (formData) => {
  const response = await axios.post(
    'https://cms.gmart.in/assign-user-to-website',
    formData, // no need to wrap in `{ FormData }`
    {
      headers: {
        'Content-Type': 'application/json',
        // Add token only if needed
        'Authorization': `Bearer ${token}`,
      }
    }
  );
  return response;
};
export const userVerify = async (formData) => {
  const response = await axios.post(
    'https://cms.gmart.in/confirm-user',
    formData, // no need to wrap in `{ FormData }`
    {
      headers: {
        'Content-Type': 'application/json',
        // Add token only if needed
        'Authorization': `Bearer ${token}`,
      }
    }
  );
  return response;
};

export const signup = async (body) => {
    return await axios.post(`${API_URL}/user-sign-up`, body);
  };
export const blogslisting = async (selectedValue) => {
  const body = {
    "filters":{
       // "website":["gmart.in","network.gmart.in", "automation.gmart.in"]
       "website": `${selectedValue}`
    },
    "nextPaginationKey":""
}
  const response = await axios.post(`https://cms.gmart.in/get_blogs`, body);
  return response.data;
}
export const createblogs = async (body) => {
  const isAuthenticated = localStorage.getItem('authToken');
  try {
    const response = await axios.post(`https://cms.gmart.in/create_blogs`, body, {
      headers: {
        Authorization: `Bearer ${isAuthenticated}`,
      },
    });
    console.log("Success:", response.data);
    return response;
  } catch (error) {
    console.log("error",error);
    throw error;
  }
}
export const updateblogs = async (body) => {
  const isAuthenticated = localStorage.getItem('authToken');
  try {
    const response = await axios.post(`https://cms.gmart.in/blogs_update`, body, {
      headers: {
        Authorization: `Bearer ${isAuthenticated}`,
      },
    });
    console.log("Success:", response.data);
    return response;
  } catch (error) {
    console.log("error",error);
    throw error;
  }
}
export const linkapi = async (body) => {
  
  const response = await axios.get(`${body}`);
  return response;
};
